/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {CrmType} from '../models/CrmType';
import type {Error} from '../models/Error';
import type {LinkageStatistics} from '../models/LinkageStatistics';

export interface GetLinkageStatistic$Request {
    accountId: number;
    licenseId: number;
    crmType: CrmType;
}

export interface GetLinkageStatistic$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getLinkageStatisticRequest = createAction<PayloadData<void, GetLinkageStatistic$Request>>('CRM_LINKAGE_STATISTIC_CONTROLLER__GET_LINKAGE_STATISTIC__REQUEST');
export const getLinkageStatisticSuccess = createAction<PayloadData<LinkageStatistics, GetLinkageStatistic$Request>>('CRM_LINKAGE_STATISTIC_CONTROLLER__GET_LINKAGE_STATISTIC__SUCCESS');
export const getLinkageStatisticFailure = createAction<PayloadData<Error, GetLinkageStatistic$Request, true>>('CRM_LINKAGE_STATISTIC_CONTROLLER__GET_LINKAGE_STATISTIC__FAILURE');

export const getLinkageStatisticActions = [
    getLinkageStatisticRequest,
    getLinkageStatisticSuccess,
    getLinkageStatisticFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {number} meta.licenseId
 * @param {CrmType} meta.crmType
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getLinkageStatistic = (meta: GetLinkageStatistic$Request, config?: GetLinkageStatistic$Config) => {
    const TRANSPORT_GET_PARAMS = {
        licenseId: meta.licenseId,
        crmType: meta.crmType,
    };
    return {
        CALL_API: {
            types: getLinkageStatisticActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/crm/${meta.accountId}/linkage-statistic`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface ReconcileLinkageStatistic$Request {
    accountId: number;
    crmType: CrmType;
}

export interface ReconcileLinkageStatistic$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const reconcileLinkageStatisticRequest = createAction<PayloadData<void, ReconcileLinkageStatistic$Request>>('CRM_LINKAGE_STATISTIC_CONTROLLER__RECONCILE_LINKAGE_STATISTIC__REQUEST');
export const reconcileLinkageStatisticSuccess = createAction<PayloadData<void, ReconcileLinkageStatistic$Request>>('CRM_LINKAGE_STATISTIC_CONTROLLER__RECONCILE_LINKAGE_STATISTIC__SUCCESS');
export const reconcileLinkageStatisticFailure = createAction<PayloadData<Error, ReconcileLinkageStatistic$Request, true>>('CRM_LINKAGE_STATISTIC_CONTROLLER__RECONCILE_LINKAGE_STATISTIC__FAILURE');

export const reconcileLinkageStatisticActions = [
    reconcileLinkageStatisticRequest,
    reconcileLinkageStatisticSuccess,
    reconcileLinkageStatisticFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {CrmType} meta.crmType
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const reconcileLinkageStatistic = (meta: ReconcileLinkageStatistic$Request, config?: ReconcileLinkageStatistic$Config) => {
    const TRANSPORT_GET_PARAMS = {
        crmType: meta.crmType,
    };
    return {
        CALL_API: {
            types: reconcileLinkageStatisticActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/crm/${meta.accountId}/linkage-statistic`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

